import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';


export interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-header',

  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    RouterModule 
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit {
  @Output() toggleSidebarRequest = new EventEmitter<void>();
  
  // This will now be dynamically populated.
  public breadcrumbs: Breadcrumb[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Re-create breadcrumbs on each successful navigation
      this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    });
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
  }

  /**
   * Recursively builds the breadcrumb array from the router state.
   * @param route The current activated route.
   * @param url The URL built so far.
   * @param breadcrumbs The array of breadcrumbs built so far.
   * @returns An array of Breadcrumb objects.
   */
  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs; // Base case: no more children
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      // Check for the 'breadcrumb' data property on the route
      const label = child.snapshot.data['breadcrumb'];
      if (label && !breadcrumbs.find(b => b.label === label)) {
        breadcrumbs.push({ label, url });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }

  onNotificationClick(): void {
    console.log('Notification clicked');
  }

  onSettingsClick(): void {
    console.log('Settings clicked');
  }

  onIconClick(): void {
    console.log('Icon clicked');
  }

  onToggleSidebar(): void {
    this.toggleSidebarRequest.emit();
  }
}
